import _ from 'lodash'

export function valuesInStep (step) {
  if (!step) return null
  const values = _.get(step, 'values', [])
  return _.filter(values, function (o) {
    return o
  })
}

export function valueInStep (step, valueId) {
  const values = valuesInStep(step)
  if (!values) return null
  return _.find(values, ['id', valueId]) || null
}

export function optionsForValueInStep (step, valueId) {
  const value = valueInStep(step, valueId)
  return _.get(value, 'options', [])
}

export function optionForValueInStep (step, valueId, optionId) {
  const options = optionsForValueInStep(step, valueId)
  return _.find(options, ['id', optionId])
}

export function defaultDocumentTitleExtractor(step) {
  const stepName = toFriendlyTitle(step)
  const { preQuoteProgress, postQuoteProgress } = step
  if (preQuoteProgress < 100) {
    return 'Your Supply | ' + stepName
  }
  if (postQuoteProgress > 0) {
    return 'Switch Info | ' + stepName
  }
  return stepName
}

export const toFriendlyTitle = (step) => {
  const stepName = step.name
  const withoutValueSuffix = _.replace(stepName, 'Step', '')
  const friendlyStepName = _.join(_.words(withoutValueSuffix), ' ')
  return _.startCase(friendlyStepName)
}

export const replaceValueIdsForLabels = (step, values) => {
  if (!step || !values) return {}
  return _.reduce(Object.keys(values), (acc, key) => {
    const value = values[key]
    const option = optionForValueInStep(step, key, value)
    acc[key] = option?.label ?? value
    return acc
  }, {})
}

export const quoteInStep = (quoteStep, quoteId) => {
  const quotes = quoteStep.quotes.searchResults
  return _.find(quotes, { id: quoteId })
}

export const supplierForQuote = (quoteStep, quoteId) => {
  const quote = quoteInStep(quoteStep, quoteId)
  const suppliers = quoteStep.suppliers
  return _.find(suppliers, { id: quote?.supplierId })
}
